import {Map, fromJS, List} from "immutable";

import {
    GET_WORK_REPORTS_SUCCESS,
    GET_WORK_REPORTS_REQUEST,
    GET_WORK_REPORTS_ERROR,

    GET_WORK_REPORT_REQUEST,
    GET_WORK_REPORT_SUCCESS,
    GET_WORK_REPORT_ERROR,

    CREATE_WORK_REPORTS_REQUEST,
    CREATE_WORK_REPORTS_SUCCESS,
    CREATE_WORK_REPORTS_ERROR,

    UPDATE_WORK_REPORT_REQUEST,
    UPDATE_WORK_REPORT_SUCCESS,
    UPDATE_WORK_REPORT_ERROR,

    DELETE_WORK_REPORT_REQUEST,
    DELETE_WORK_REPORT_SUCCESS,
    DELETE_WORK_REPORT_ERROR,

    CLEAN_WORK_REPORTS
} from '../actions/work-reports';

const workReports = (state = Map({
  payload: List([]),
  isFetching: false,
  error: false
}), action) => {
  let newState, updatedPayload, index, payload = state.get('payload');
  switch (action.type) {

      // Requests
      case GET_WORK_REPORTS_REQUEST:
      case GET_WORK_REPORT_REQUEST:
      case CREATE_WORK_REPORTS_REQUEST:
      case UPDATE_WORK_REPORT_REQUEST:
      case DELETE_WORK_REPORT_REQUEST:
          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      // Success
      case GET_WORK_REPORTS_SUCCESS:
      case GET_WORK_REPORT_SUCCESS:
      case CLEAN_WORK_REPORTS:
          newState = state.merge({
              payload: fromJS(action.payload),
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      case CREATE_WORK_REPORTS_SUCCESS:
          // Check if payload is a List (Array)
          if(List.isList(payload)) {
              updatedPayload = new List(payload);
              action.payload.forEach(item => {
                  updatedPayload = updatedPayload.push(fromJS(item));
              });
          }
          // If payload is a Map the payload to be updated is action.payload itself
          else if(Map.isMap(payload)) {
              updatedPayload = fromJS(action.payload);
          }

          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error,
              created: action.created,
              payload: updatedPayload
          });
          return newState;

      case UPDATE_WORK_REPORT_SUCCESS:

          // Check if payload is a List (Array)
          if(List.isList(payload)) {

              // Find the index of the work-report to be updated inside the List
              index = payload.findIndex(item => {
                  return item.get('_id') === action.payload._id;
              });

              // Update the payload list
              if (index !== -1) {
                  updatedPayload = payload.update(index, () => {
                      return fromJS(action.payload);
                  });
              }


              // If payload is a Map the payload to be updated is action.payload itself
          }
          else if(Map.isMap(state.get('payload'))) {
              updatedPayload = fromJS(action.payload);
          }
          newState = state
              .merge({
                  isFetching: action.isFetching,
                  error: action.error,
                  updated: action.updated,
                  payload: updatedPayload
              });
          return newState;
      case DELETE_WORK_REPORT_SUCCESS:
          updatedPayload = payload.filter( workReport => {
              return workReport.get('_id') !== action.payload._id;
          });
          newState = state.merge({
              payload: updatedPayload,
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      // Errors
      case GET_WORK_REPORTS_ERROR:
      case GET_WORK_REPORT_ERROR:
      case CREATE_WORK_REPORTS_ERROR:
      case UPDATE_WORK_REPORT_ERROR:
      case DELETE_WORK_REPORT_ERROR:
          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error,
              errorMessage: action.errorMessage
          });
          return newState;
      default:
          return state;
  }
};

export default workReports;



// WEBPACK FOOTER //
// ./src/reducers/work-reports.js